module.exports = __webpack_public_path__ + "static/media/es-ga.26a8b2bf.svg";